// extracted by mini-css-extract-plugin
module.exports = {"image":"product-out-of-stock_image__c9XYm","imageContainer":"product-out-of-stock_imageContainer__734Zs"};